import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import useDialog from 'hooks/useDialog';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Button from '../../../Shopper/Button';

const DownloadAppDialog = dynamic(() => import('./Dialog'), { ssr: false });

const DownloadAppButton = ({ gaEventCategory }) => {
  const { showDialog } = useDialog();

  const onDownloadApp = () => {
    sendEvent({
      action: 'download_app__click',
      category: gaEventCategory,
    });
    showDialog(DownloadAppDialog);
  };

  return (
    <Button
      aria-label="Download app Promobit"
      as="a"
      icon={<Icon name="iphone" />}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onDownloadApp}
    >
      {placeholder('actions.downloadAppButton')}
    </Button>
  );
};

DownloadAppButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default DownloadAppButton;
